import {
    newsletterSubscriptionForm as sourceNewsletterSubscriptionForm,
} from 'SourceComponent/NewsletterSubscription/NewsletterForm.form';

//TODO: implement newsletterSubscriptionForm
export const newsletterSubscriptionForm = sourceNewsletterSubscriptionForm;

export default newsletterSubscriptionForm;
